/**
 * This file was automatically generated using style dictionary. Do not edit directly.
 */

export const baseTokens = {
    color: {
        core: {
            brand: "#5f259f",
            primary: "#873ae3",
            primarySubtle: "#f1e9fe",
            primarySubtler: "#f9f5ff",
            primaryBold: "#7228c8",
        },
        bg: {
            default: "#f9fafb",
            surface: {
                default: "#ffffff",
                surfaceLayer2: "#f9fafb",
                surfaceLayer3: "#f2f4f7",
                surfaceLayer4: "#eaecf0",
                surfaceInverse: "#101828",
                surfaceDisabled: "#0000000d",
                surfacePrimary: "#f9f5ff",
                surfaceCaution: "#fffaeb",
                surfaceDanger: "#fef3f2",
                surfaceSuccess: "#ecfdf3",
                surfaceInfo: "#eff8ff",
                surfaceBrand: "#f9f5ff",
            },
            fill: {
                default: "#ffffff",
                fillHover: "#f9fafb",
                fillActive: "#f9fafb",
                fillSelected: "#f2f4f7",
                fillDisabled: "#0000001a",
                fillSubtle: "#eaecf0",
                fillSubtler: "#f9fafb",
                fillPrimary: "#873ae3",
                fillPrimaryHover: "#9d5bf1",
                fillPrimaryActive: "#7228c8",
                fillPrimarySelected: "#873ae3",
                fillPrimaryDisabled: "#0000001a",
                fillPrimarySubtle: "#f1e9fe",
                fillPrimarySubtler: "#f9f5ff",
                fillDanger: "#d92d20",
                fillDangerSubtle: "#fee4e2",
                fillDangerSubtler: "#fef3f2",
                fillCaution: "#dc6803",
                fillCautionSubtle: "#fef0c7",
                fillCautionSubtler: "#fffaeb",
                fillInfo: "#1570ef",
                fillInfoSubtle: "#d1e9ff",
                fillInfoSubtler: "#eff8ff",
                fillSuccess: "#039855",
                fillSuccessSubtle: "#d1fadf",
                fillSuccessSubtler: "#ecfdf3",
                fillBrand: "#5f259f",
            },
            overlay: "#00000080",
        },
        text: {
            default: "#3d3d3d",
            textSecondary: "#4f4f4f",
            textTertiary: "#888888",
            textDisabled: "#00000033",
            textInverse: "#ffffff",
            textInverseSecondary: "#e7e7e7",
            textInverseTertiary: "#b0b0b0",
            textInverseDisabled: "#ffffff33",
            textLink: "#175cd3",
            textLinkHover: "#1570ef",
            textLinkActive: "#1849a9",
            textPrimary: "#7228c8",
            textSuccess: "#027a48",
            textCaution: "#b54708",
            textDanger: "#b42318",
            textInfo: "#175cd3",
            textBrand: "#5f259f",
        },
        icon: {
            default: "#454545",
            iconHover: "#3d3d3d",
            iconActive: "#000000",
            iconSecondary: "#5d5d5d",
            iconTertiary: "#d1d1d1",
            iconDisabled: "#0000001a",
            iconInverse: "#ffffff",
            iconInverseSecondary: "#e7e7e7",
            iconPrimary: "#7228c8",
            iconSuccess: "#039855",
            iconCaution: "#dc6803",
            iconDanger: "#d92d20",
            iconInfo: "#1570ef",
            iconBrand: "#5f259f",
            accent: {
                accentGray1: "#f2f4f7",
                accentGray2: "#f9fafb",
                accentBlue1: "#d1e9ff",
                accentBlue2: "#eff8ff",
                accentRed1: "#fee4e2",
                accentRed2: "#fef3f2",
                accentAmber1: "#fedf89",
                accentAmber2: "#fef0c7",
                accentGreen1: "#d1fadf",
                accentGreen2: "#ecfdf3",
                accentCyan1: "#cff9fe",
                accentCyan2: "#ecfdff",
                accentPink1: "#fce7f6",
                accentPink2: "#fdf2fa",
                accentOrange1: "#fdead7",
                accentOrange2: "#fef6ee",
            },
        },
        border: {
            default: "#d0d5dd",
            borderSecondary: "#eaecf0",
            borderInverse: "#ffffff4d",
            borderDisabled: "#0000001a",
            borderBold: "#667085",
            borderFocus: "#2e90fa",
            borderPrimary: "#b888f8",
            borderPrimaryBold: "#7228c8",
            borderSuccess: "#32d583",
            borderSuccessBold: "#039855",
            borderCaution: "#fdb022",
            borderCautionBold: "#dc6803",
            borderDanger: "#f97066",
            borderDangerBold: "#d92d20",
            borderInfo: "#53b1fd",
            borderInfoBold: "#1570ef",
            borderBrand: "#5f259f",
        },
        Nav: {
            navBg: "#ffffff",
            navBgSurface: "#e7e7e7",
            navBgSurfaceHover: "#0000000d",
            navBgSurfaceSelected: "#f2f4f7",
        },
        Input: {
            inputBgSurface: "#ffffff",
            inputBgSurfaceHover: "#fcfcfd",
            inputBgSurfaceActive: "#ffffff",
            inputBgSurfaceDisabled: "#f2f4f7",
            inputBorder: "#d0d5dd",
            inputBorderActive: "#b888f8",
            inputBorderDisabled: "#eaecf0",
        },
        Selection: {
            selectionBgFill: "#f9f5ff",
            selectionBgFillSelected: "#873ae3",
            selectionBorderActive: "#873ae3",
        },
        Toggle: {
            toggleTrackBg: "#eaecf0",
            toggleTrackBgHover: "#d0d5dd",
            toggleTrackBgActive: "#873ae3",
            toggleTrackBgDisabled: "#0000001a",
            toggleKnobSurfaceDisabled: "#f6f6f6",
        },
        Avatar: {
            avatarBgFill1: "#f2f4f7",
            avatarBgFill2: "#fee4e2",
            avatarBgFill3: "#d1fadf",
            avatarBgFill4: "#cff9fe",
            avatarBgFill5: "#fef0c7",
            avatarTextOnBgFill: "#475467",
            avatarTextOnBgFillInverse: "#ffffff",
        },
        code: {
            code1: "#3538cd",
            code2: "#b93815",
            code3: "#9f1ab1",
            code4: "#027a48",
            code5: "#7228c8",
        },
    },
    h1: {
        regular: {
            fontFamily: "Inter",
            fontSize: "32px",
            fontWeight: "400",
            letterSpacing: "0%",
            lineHeight: "150%",
            textTransform: "none",
            textDecoration: "none",
        },
        medium: {
            fontFamily: "Inter",
            fontSize: "32px",
            fontWeight: "500",
            letterSpacing: "0%",
            lineHeight: "150%",
            textTransform: "none",
            textDecoration: "none",
        },
        semiBold: {
            fontFamily: "Inter",
            fontSize: "32px",
            fontWeight: "600",
            letterSpacing: "0%",
            lineHeight: "150%",
            textTransform: "none",
            textDecoration: "none",
        },
        bold: {
            fontFamily: "Inter",
            fontSize: "32px",
            fontWeight: "700",
            letterSpacing: "0%",
            lineHeight: "150%",
            textTransform: "none",
            textDecoration: "none",
        },
    },
    h2: {
        regular24: {
            fontFamily: "Inter",
            fontSize: "24px",
            fontWeight: "400",
            letterSpacing: "0%",
            lineHeight: "150%",
            textTransform: "none",
            textDecoration: "none",
        },
        medium24: {
            fontFamily: "Inter",
            fontSize: "24px",
            fontWeight: "500",
            letterSpacing: "0%",
            lineHeight: "150%",
            textTransform: "none",
            textDecoration: "none",
        },
        semiBold24: {
            fontFamily: "Inter",
            fontSize: "24px",
            fontWeight: "600",
            letterSpacing: "0%",
            lineHeight: "150%",
            textTransform: "none",
            textDecoration: "none",
        },
        bold24: {
            fontFamily: "Inter",
            fontSize: "24px",
            fontWeight: "700",
            letterSpacing: "0%",
            lineHeight: "150%",
            textTransform: "none",
            textDecoration: "none",
        },
    },
    h3: {
        regular20: {
            fontFamily: "Inter",
            fontSize: "20px",
            fontWeight: "400",
            letterSpacing: "0%",
            lineHeight: "140%",
            textTransform: "none",
            textDecoration: "none",
        },
        medium20: {
            fontFamily: "Inter",
            fontSize: "20px",
            fontWeight: "500",
            letterSpacing: "0%",
            lineHeight: "140%",
            textTransform: "none",
            textDecoration: "none",
        },
        semiBold20: {
            fontFamily: "Inter",
            fontSize: "20px",
            fontWeight: "600",
            letterSpacing: "0%",
            lineHeight: "140%",
            textTransform: "none",
            textDecoration: "none",
        },
        bold20: {
            fontFamily: "Inter",
            fontSize: "20px",
            fontWeight: "700",
            letterSpacing: "0%",
            lineHeight: "140%",
            textTransform: "none",
            textDecoration: "none",
        },
    },
    h4: {
        regular18: {
            fontFamily: "Inter",
            fontSize: "18px",
            fontWeight: "400",
            letterSpacing: "0%",
            lineHeight: "140%",
            textTransform: "none",
            textDecoration: "none",
        },
        medium18: {
            fontFamily: "Inter",
            fontSize: "18px",
            fontWeight: "500",
            letterSpacing: "0%",
            lineHeight: "140%",
            textTransform: "none",
            textDecoration: "none",
        },
        semiBold18: {
            fontFamily: "Inter",
            fontSize: "18px",
            fontWeight: "600",
            letterSpacing: "0%",
            lineHeight: "140%",
            textTransform: "none",
            textDecoration: "none",
        },
        bold18: {
            fontFamily: "Inter",
            fontSize: "18px",
            fontWeight: "700",
            letterSpacing: "0%",
            lineHeight: "140%",
            textTransform: "none",
            textDecoration: "none",
        },
    },
    body: {
        lg: {
            regular: {
                fontFamily: "Inter",
                fontSize: "16px",
                fontWeight: "400",
                letterSpacing: "0%",
                lineHeight: "150%",
                textTransform: "none",
                textDecoration: "none",
            },
            medium: {
                fontFamily: "Inter",
                fontSize: "16px",
                fontWeight: "500",
                letterSpacing: "0%",
                lineHeight: "150%",
                textTransform: "none",
                textDecoration: "none",
            },
            semiBold16: {
                fontFamily: "Inter",
                fontSize: "16px",
                fontWeight: "600",
                letterSpacing: "0%",
                lineHeight: "150%",
                textTransform: "none",
                textDecoration: "none",
            },
            bold: {
                fontFamily: "Inter",
                fontSize: "16px",
                fontWeight: "600",
                letterSpacing: "0%",
                lineHeight: "150%",
                textTransform: "none",
                textDecoration: "none",
            },
        },
        md: {
            regular: {
                fontFamily: "Inter",
                fontSize: "14px",
                fontWeight: "400",
                letterSpacing: "0%",
                lineHeight: "145%",
                textTransform: "none",
                textDecoration: "none",
            },
            medium: {
                fontFamily: "Inter",
                fontSize: "14px",
                fontWeight: "500",
                letterSpacing: "0%",
                lineHeight: "145%",
                textTransform: "none",
                textDecoration: "none",
            },
            semiBold: {
                fontFamily: "Inter",
                fontSize: "14px",
                fontWeight: "600",
                letterSpacing: "0%",
                lineHeight: "145%",
                textTransform: "none",
                textDecoration: "none",
            },
            bold: {
                fontFamily: "Inter",
                fontSize: "14px",
                fontWeight: "600",
                letterSpacing: "0%",
                lineHeight: "145%",
                textTransform: "none",
                textDecoration: "none",
            },
        },
        sm: {
            regular: {
                fontFamily: "Inter",
                fontSize: "12px",
                fontWeight: "400",
                letterSpacing: "0%",
                lineHeight: "130%",
                textTransform: "none",
                textDecoration: "none",
            },
            medium: {
                fontFamily: "Inter",
                fontSize: "12px",
                fontWeight: "500",
                letterSpacing: "0%",
                lineHeight: "130%",
                textTransform: "none",
                textDecoration: "none",
            },
        },
    },
    footnote: {
        regular12: {
            fontFamily: "Inter",
            fontSize: "12px",
            fontWeight: "400",
            letterSpacing: "0%",
            lineHeight: "165%",
            textTransform: "none",
            textDecoration: "none",
        },
        medium: {
            fontFamily: "Inter",
            fontSize: "12px",
            fontWeight: "500",
            letterSpacing: "0%",
            lineHeight: "165%",
            textTransform: "none",
            textDecoration: "none",
        },
        semiBold12: {
            fontFamily: "Inter",
            fontSize: "12px",
            fontWeight: "600",
            letterSpacing: "0%",
            lineHeight: "165%",
            textTransform: "none",
            textDecoration: "none",
        },
        bold: {
            fontFamily: "Inter",
            fontSize: "12px",
            fontWeight: "600",
            letterSpacing: "0%",
            lineHeight: "165%",
            textTransform: "none",
            textDecoration: "none",
        },
    },
    code: {
        md: {
            regular: {
                fontFamily: "IBM Plex Mono",
                fontSize: "14px",
                fontWeight: "400",
                letterSpacing: "0%",
                lineHeight: "145%",
                textTransform: "none",
                textDecoration: "none",
            },
            medium: {
                fontFamily: "IBM Plex Mono",
                fontSize: "14px",
                fontWeight: "500",
                letterSpacing: "0%",
                lineHeight: "145%",
                textTransform: "none",
                textDecoration: "none",
            },
            semiBold: {
                fontFamily: "IBM Plex Mono",
                fontSize: "14px",
                fontWeight: "600",
                letterSpacing: "0%",
                lineHeight: "145%",
                textTransform: "none",
                textDecoration: "none",
            },
            bold14: {
                fontFamily: "IBM Plex Mono",
                fontSize: "14px",
                fontWeight: "600",
                letterSpacing: "0%",
                lineHeight: "145%",
                textTransform: "none",
                textDecoration: "none",
            },
        },
        sm: {
            regular: {
                fontFamily: "IBM Plex Mono",
                fontSize: "12px",
                fontWeight: 400,
                letterSpacing: "0%",
                lineHeight: "135%",
                textTransform: "none",
                textDecoration: "none",
            },
            medium: {
                fontFamily: "IBM Plex Mono",
                fontSize: "12px",
                fontWeight: 500,
                letterSpacing: "0%",
                lineHeight: "135%",
                textTransform: "none",
                textDecoration: "none",
            },
            semiBold: {
                fontFamily: "IBM Plex Mono",
                fontSize: "12px",
                fontWeight: 600,
                letterSpacing: "0%",
                lineHeight: "135%",
                textTransform: "none",
                textDecoration: "none",
            },
            bold14: {
                fontFamily: "IBM Plex Mono",
                fontSize: "12px",
                fontWeight: 700,
                letterSpacing: "0%",
                lineHeight: "135%",
                textTransform: "none",
                textDecoration: "none",
            },
        },
    },
};
